import React from "react";
import { useIntegration } from "./hooks/useIntegration";
import { Layout } from "./shared/Layout";
import { Title } from "./shared/Title";
import { not } from "../../../../utilities/fp";
import { ContentWrapper } from "./shared/ContentWrapper";
import { Authorize } from "./shared/Authorize";
import { Settings } from "./shared/Settings";

export const Shopify = () => {
  const { status, set, get, act } = useIntegration();

  return (
    <Layout isLoading={status.isLoading}>
      <Title isEnabled={status.isEnabled} onToggle={() => set.isEnabled(not)} />
      {status.isEnabled && (
        <ContentWrapper
          isAuthorized={status.isAuthorized || status.isAuthorizedFromQuery}
          isSaving={status.isSaving}
          onSave={act.save}
        >
          <Authorize
            isQueryAuthorized={status.isAuthorizedFromQuery}
            authorizedOn={get.date}
            onAuthorize={act.authorize}
            isAuthorizing={status.isAuthorizing}
          />
          <Settings
            isAuthorized={status.isAuthorized || status.isAuthorizedFromQuery}
            shopDomain={get.shopDomain}
            setShopDomain={set.shopDomain}
            syncProducts={get.syncProducts}
            toggleSyncProducts={() => set.syncProducts(not)}
          />
        </ContentWrapper>
      )}
    </Layout>
  );
};
